import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-zendesk',
  templateUrl: './zendesk.component.html',
  styleUrls: ['./zendesk.component.css']
})

export class ZendeskComponent implements OnInit {
  return_to: string;

  constructor(private route: ActivatedRoute) { }
  ngOnInit() {
    this.route.queryParams
      .subscribe(params => {
        this.return_to = params.return_to;
      });

    if (this.return_to != null && this.return_to != undefined) {
      window.location.href = 'https://libertysoftware.zendesk.com/auth/v2/login/normal?return_to=' + this.return_to;
    } else {
      window.location.href = 'https://libertysoftware.zendesk.com/auth/v2/login/normal'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/Zendesk/Zendesk.component.ts